import * as types from "../actions/types/app.types";
import * as accountTypes from "../actions/types/account.types";

const initialState = {
    showErrorModal: false,
    showExpiredModal: false,
    showRetryModal: false,
    errorMessage: "",
};

export const loadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SHOW_ERROR_MODAL:
            return {
                ...state,
                showErrorModal: true,
            };
        case types.SHOW_EXPIRED_MODAL:
        case accountTypes.RESET_AUTH_TOKEN_FAILED:
            return {
                ...state,
                showExpiredModal: true,
                errorMessage: action?.payload,
            };
        case types.SHOW_RETRY_MODAL:
            return {
                ...state,
                showRetryModal: true,
            };
        case types.HIDE_ERROR_MODAL:
            return {
                ...state,
                showErrorModal: false,
            };
        case types.HIDE_EXPIRED_MODAL:
            return {
                ...state,
                showExpiredModal: false,
                errorMessage: "",
            };
        case types.HIDE_RETRY_MODAL:
            return {
                ...state,
                showRetryModal: false,
            };
        default:
            return state;
    }
};
